import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_nuxtvuexroutersync_9faa8578 from 'nuxt_plugin_nuxtvuexroutersync_9faa8578' // Source: ./nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_elementui_a6a1b20a from 'nuxt_plugin_elementui_a6a1b20a' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_vuexstore_16a5617b from 'nuxt_plugin_vuexstore_16a5617b' // Source: ../plugins/vuex-store.js (mode: 'all')
import nuxt_plugin_initmixins_68746d1e from 'nuxt_plugin_initmixins_68746d1e' // Source: ../plugins/init-mixins.js (mode: 'all')
import nuxt_plugin_initlibs_f46ea728 from 'nuxt_plugin_initlibs_f46ea728' // Source: ../plugins/init-$libs.js (mode: 'all')
import nuxt_plugin_initrequest_a246e0a2 from 'nuxt_plugin_initrequest_a246e0a2' // Source: ../plugins/init-request.js (mode: 'all')
import nuxt_plugin_initvuecomponent_3146d228 from 'nuxt_plugin_initvuecomponent_3146d228' // Source: ../plugins/init-vue-component.js (mode: 'all')
import nuxt_plugin_initsentry_448c6a31 from 'nuxt_plugin_initsentry_448c6a31' // Source: ../plugins/init-sentry.js (mode: 'all')
import nuxt_plugin_polyfill_445bbb12 from 'nuxt_plugin_polyfill_445bbb12' // Source: ../plugins/polyfill.js (mode: 'client')
import nuxt_plugin_initglobal_3db8f7ed from 'nuxt_plugin_initglobal_3db8f7ed' // Source: ../plugins/init-global.js (mode: 'client')
import nuxt_plugin_initclienthelpers_0386c40d from 'nuxt_plugin_initclienthelpers_0386c40d' // Source: ../plugins/init-client-helpers.js (mode: 'client')
import nuxt_plugin_initlogicplugin_e5545024 from 'nuxt_plugin_initlogicplugin_e5545024' // Source: ../plugins/init-logic-plugin.js (mode: 'client')
import nuxt_plugin_initvueplugin_789e3a56 from 'nuxt_plugin_initvueplugin_789e3a56' // Source: ../plugins/init-vue-plugin.js (mode: 'client')
import nuxt_plugin_xlareport_3de50aad from 'nuxt_plugin_xlareport_3de50aad' // Source: ../plugins/xla-report.js (mode: 'client')
import nuxt_plugin_xlcookie_66e16020 from 'nuxt_plugin_xlcookie_66e16020' // Source: ../plugins/xl-cookie.js (mode: 'client')
import nuxt_plugin_intersectionobserver_2e42bf93 from 'nuxt_plugin_intersectionobserver_2e42bf93' // Source: ../plugins/intersection-observer.js (mode: 'client')
import nuxt_plugin_route_192d86f8 from 'nuxt_plugin_route_192d86f8' // Source: ../plugins/route.js (mode: 'client')
import nuxt_plugin_index_24291584 from 'nuxt_plugin_index_24291584' // Source: ../plugins/f2e-sdk/index.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"迅雷游戏","meta":[{"charset":"utf-8"},{"name":"referrer","content":"no-referrer-when-downgrade"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"hid":"description","name":"description","content":"迅雷游戏官网"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fstatic2-youxi.a.88cdn.com\u002Fbackend\u002Fxl-lib\u002Fswiper-2.7.6.min.css"}],"script":[{"src":"https:\u002F\u002Fmisc-xl9-ssl.xunlei.com\u002Fres\u002Fapi\u002Fxl9\u002Fv1\u002Fxl9.js"},{"src":"https:\u002F\u002Fi.xunlei.com\u002Flogin\u002F2.5\u002FqLogin.min.js"},{"src":"\u002Fjs\u002Fjquery1.8.3.min.js"},{"src":"https:\u002F\u002Fstatic2-youxi.a.88cdn.com\u002Fbackend\u002Fxl-lib\u002Fswiper-2.7.6.min.js"},{"innerHTML":"xla = window.xla || (window.xla = []);xla.push({type: \"config\",appid: 25067,secret: \"f5dbd170cb44855c3183d7f62e47697c\"})","vmid":"xla"},{"src":"https:\u002F\u002Fres-etl-ssl.xunlei.com\u002Fv1.0.0\u002Fxla.min.js","async":true}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_nuxtvuexroutersync_9faa8578 === 'function') {
    await nuxt_plugin_nuxtvuexroutersync_9faa8578(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_a6a1b20a === 'function') {
    await nuxt_plugin_elementui_a6a1b20a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexstore_16a5617b === 'function') {
    await nuxt_plugin_vuexstore_16a5617b(app.context, inject)
  }

  if (typeof nuxt_plugin_initmixins_68746d1e === 'function') {
    await nuxt_plugin_initmixins_68746d1e(app.context, inject)
  }

  if (typeof nuxt_plugin_initlibs_f46ea728 === 'function') {
    await nuxt_plugin_initlibs_f46ea728(app.context, inject)
  }

  if (typeof nuxt_plugin_initrequest_a246e0a2 === 'function') {
    await nuxt_plugin_initrequest_a246e0a2(app.context, inject)
  }

  if (typeof nuxt_plugin_initvuecomponent_3146d228 === 'function') {
    await nuxt_plugin_initvuecomponent_3146d228(app.context, inject)
  }

  if (typeof nuxt_plugin_initsentry_448c6a31 === 'function') {
    await nuxt_plugin_initsentry_448c6a31(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfill_445bbb12 === 'function') {
    await nuxt_plugin_polyfill_445bbb12(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initglobal_3db8f7ed === 'function') {
    await nuxt_plugin_initglobal_3db8f7ed(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initclienthelpers_0386c40d === 'function') {
    await nuxt_plugin_initclienthelpers_0386c40d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initlogicplugin_e5545024 === 'function') {
    await nuxt_plugin_initlogicplugin_e5545024(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initvueplugin_789e3a56 === 'function') {
    await nuxt_plugin_initvueplugin_789e3a56(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_xlareport_3de50aad === 'function') {
    await nuxt_plugin_xlareport_3de50aad(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_xlcookie_66e16020 === 'function') {
    await nuxt_plugin_xlcookie_66e16020(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intersectionobserver_2e42bf93 === 'function') {
    await nuxt_plugin_intersectionobserver_2e42bf93(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_route_192d86f8 === 'function') {
    await nuxt_plugin_route_192d86f8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_24291584 === 'function') {
    await nuxt_plugin_index_24291584(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
